export const GET_PROVIDERS = 'GET_PROVIDERS';
export const SET_PROVIDERS_PAGINATION = 'SET_PROVIDERS_PAGINATION';
export const SET_PROVIDERS_FILTERS = 'SET_PROVIDERS_FILTERS';
export const RESET_PROVIDERS = 'RESET_PROVIDERS';
export const TOGGLE_PROVIDER = 'TOGGLE_PROVIDER';
export const ADD_PROVIDER = 'ADD_PROVIDER';
export const UPDATE_PROVIDER = 'UPDATE_PROVIDER';
export const GET_PROVIDER_BY_ID = 'GET_PROVIDER_BY_ID';
export const RESET_PROVIDER_FORM = 'RESET_PROVIDER_FORM';
export const MODIFY_EDITING_PROVIDER = 'MODIFY_EDITING_PROVIDER';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_PROVIDER = 'MODIFY_CUSTOM_FIELD_EDITING_PROVIDER';



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/constants/providers_constants.js